import React from "react";
import styles from "./BrokerCRM/BrokerCRM.module.css";
import logoPng from "../assets/mm-logo.png";

export default function ClientTopNav() {
  return (
    <header className={styles.crmTopNavWrap}>
      <div className={styles.crmTopNav}>
        {/* Left: Logo */}
        <a
          className={styles.crmBrand}
          href="https://www.mortgagematrix.com.au"
          aria-label="Mortgage Matrix"
        >
          <img
            className={styles.crmLogo}
            src={logoPng}
            alt="Mortgage Matrix"
          />
        </a>

        {/* Spacer */}
        <div style={{ flex: 1 }} />

        {/* Right: Contact */}
        <div className={styles.crmNavActions}>
          {/* Desktop phone pill */}
          <a
            className={`${styles.crmPhonePill} ${styles.crmHideMobile}`}
            href="tel:1300537267"
            aria-label="Call Mortgage Matrix"
          >
            <span className={styles.crmPhoneIcon} aria-hidden="true">
              📞
            </span>
            <span>1300 537 267</span>
          </a>

          {/* Mobile phone icon */}
          <a
            className={`${styles.crmIconBtn} ${styles.crmShowMobile}`}
            href="tel:1300537267"
            aria-label="Call Mortgage Matrix"
            title="Call Mortgage Matrix"
          >
            📞
          </a>
        </div>
      </div>
    </header>
  );
}